// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".music-control-mv[data-v-69d18f9c],.music-media[data-v-69d18f9c]{z-index:1}.music-control-mv[data-v-69d18f9c],.music-media[data-v-69d18f9c],.music_img[data-v-69d18f9c]{position:absolute;top:0;height:10rem;width:100%;-o-object-fit:cover;object-fit:cover}.music_img[data-v-69d18f9c]{z-index:0}", ""]);
// Exports
module.exports = exports;
